module.exports = __webpack_public_path__ + "8f0ec3ecc93720884314c2535bb9fccb.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/KG.svg
// module id = ED59
// module chunks = 0